import { Card, Image, Text, makeStyles, tokens } from '@fluentui/react-components';
import { CheckmarkCircle16Filled } from '@fluentui/react-icons';
import Form from './Form';
import IContactForm from '../../models/page/IContactForm';

const useStyles = makeStyles({
	mainContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '20px'
	},
	row: {
		display: 'flex',
		justifyContent: 'center',
		width: '80%',
		flexDirection: 'column',
		alignItems: 'center',
		marginBottom: '20px',
		"@media(max-width: 768px)": {
			width: '95%',
		}
	},
	contentContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		margin: '15px 0',

		'@media(min-width: 768px)': {
			flexDirection: 'row',
		}
	},
	title: {
		marginBottom: '5px',
		textAlign: 'center',
	},
	subtitle: {
		color: tokens.colorNeutralForeground3,
		textAlign: 'center',
	},
	bulletList: {
		display: 'flex',
		flexDirection: 'column',
		gap: '0.4rem',
		marginTop: '1rem',
		marginBottom: '1rem',
		alignItems: 'flex-start',
	},
	bulletItem: {
		display: 'flex',
		alignItems: 'center',
		gap: '0.5rem',
		color: tokens.colorNeutralForeground2,
	},
	bulletIcon: {
		color: tokens.colorBrandForeground1,
		flexShrink: 0,
	},
	illustration: {
		width: '100%',
		height: 'auto',
		maxWidth: '300px',
		marginBottom: '20px',

		'@media(min-width: 768px)': {
			marginBottom: '0',
			marginRight: '20px',
		}
	},
	formCard: {
		width: '100%',
		maxWidth: '600px',
	}
});

export default function ContactForm(props: IContactForm) {
	const styles = useStyles();
	return (
		<div className={styles.mainContainer}>
			<div className={styles.row}>
				<Text block size={800} className={styles.title}>
					{props.title}
				</Text>

				{Array.isArray(props.bullets) && props.bullets.length > 0 && (
					<div className={styles.bulletList}>
						{props.bullets.map((bullet) => (
							<div key={bullet} className={styles.bulletItem}>
								<CheckmarkCircle16Filled className={styles.bulletIcon} />
								<Text size={300}>{bullet}</Text>
							</div>
						))}
					</div>
				)}

				<Text block size={500} className={styles.subtitle}>
					{props.subtitle}
				</Text>
			</div>
			<div className={styles.contentContainer}>
				<Image
					src="/img/illustrations/illustration-1.png"
					alt="Contact us"
					className={styles.illustration}
				/>

				<Card className={styles.formCard} appearance='filled-alternative'>
					<Form />
				</Card>
			</div>
		</div>
	);
}